import styled from 'styled-components'

export const AudioSearchResultContainer = styled.div`
  flex: 1;
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`
